import React from 'react'
import CollegeDetailsBody from './Components/CollegeDetailsBody'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import { useParams } from 'react-router-dom'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function CollegeDetailsPage() {
  const {slug} = useParams();
  const page = 'colleges';
  return (
        <>
        <SEOHelmet page={page} collegeId={slug}/>
            {/* topbar */}
                <div className='bg-main main pb-4'>
                    {/* <TopBar/> */}
                    <CollegeDetailsBody/>
                </div>
                <IndexFooter/>

        </>
  )
}

export default CollegeDetailsPage